import api from "./api.ts";
import Constant from "../global/Constant.ts";

const PATH = Constant.assetcategory;

const assetCategoryService = {

  async getAllCategories(currentPage = 1, perPage = 10) {
    const { data } = await api.get(PATH, {
      params: { currentPage, perPage },
    });
    return data;
  },


  async getAllCategoriesWithoutPagination() {
    const { data } = await api.get(PATH, {
      params: { active: true },
    });
    return data;
  },

  async getAllActiveCategories() {
  const { data } = await api.get(PATH, {
    params: {
      active: true,
      allActive: true,
    },
  });
  return data;
},


 
  async createCategory(category: { CategoryName: string; Status?: number }) {
    const { data } = await api.post(PATH, category);
    return data;
  },


  async updateCategory(category: {
    CategoryID: number;
    CategoryName: string;
    Status?: number;
  }) {
    const { data } = await api.put(PATH, category);
    return data;
  },


  async deleteCategory(CategoryID: number) {
    const { data } = await api.delete(PATH, {
      data: { CategoryID },
    });
    return data;
  },
};

export default assetCategoryService;
